<template>
  <div class="thirteen-container" ref="container">
    <div class="img-container">
      <img
        src="https://jcdn.xhby.net/project/lianghui/new-assets/thirteen-city/bg.jpg"
        alt=""
        class="thirteen-img"
        ref="bgImg"
      />
      <div
        class="point-container"
        v-for="(city, i) in hotPoints"
        :key="i"
        :style="{
          top: `${compute640(city.y)}px`,
          paddingLeft: `${compute640Point(city.x)}px`,
        }"
        @click="next(city.city)"
      >
        <img
          src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/thirteen-city/point.png"
          alt=""
          class="point-img"
        />
      </div>

      <div class="cloud-container">
        <template v-for="(c, i) in cloud">
          <img
            :key="i"
            :style="{
              left: `${compute640(c.x)}px`,
              top: `${compute640(c.y)}px`,
            }"
            src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/thirteen-city/c1.png"
            alt=""
            v-if="i % 3 === 0"
            class="c1"
          />
          <img
            :key="i"
            :style="{
              left: `${compute640(c.x)}px`,
              top: `${compute640(c.y)}px`,
            }"
            src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/thirteen-city/c2.png"
            alt=""
            v-if="i % 3 === 1"
            class="c2"
          />
          <img
            :key="i"
            :style="{
              left: `${compute640(c.x)}px`,
              top: `${compute640(c.y)}px`,
            }"
            src="https://jhd-o1.oss-cn-hangzhou.aliyuncs.com/project/lianghui/assets/thirteen-city/c3.png"
            alt=""
            v-if="i % 3 === 2"
            class="c3"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hotPoints: [
        {
          x: 56,
          y: 52,
          city: "nanjing",
        },
        {
          x: 58,
          y: 158,
          city: "suzhou",
        },
        {
          x: 60,
          y: 210,
          city: "wuxi",
        },
        {
          x: 60,
          y: 294,
          city: "changzhou",
        },
        {
          x: 55,
          y: 345,
          city: "zhenjiang",
        },
        {
          x: 55,
          y: 442,
          city: "yangzhou",
        },
        {
          x: 55,
          y: 490,
          city: "taizhou",
        },
        {
          x: 68,
          y: 580,
          city: "nantong",
        },
        {
          x: -10,
          y: 642,
          city: "yancheng",
        },
        {
          x: 70,
          y: 733,
          city: "huaian",
        },
        {
          x: 45,
          y: 790,
          city: "suqian",
        },
        {
          x: 62,
          y: 863,
          city: "xuzhou",
        },
        {
          x: 47,
          y: 920,
          city: "lianyungang",
        },
      ],
      cloud: [
        {
          x: 20,
          y: 10,
        },
        {
          x: 2,
          y: 120,
        },
        {
          x: 50,
          y: 200,
        },
        {
          x: 40,
          y: 310,
        },
        {
          x: 25,
          y: 440,
        },
        {
          x: 40,
          y: 510,
        },
        {
          x: 4,
          y: 570,
        },
        {
          x: 40,
          y: 680,
        },
        {
          x: 0,
          y: 750,
        },
        {
          x: 80,
          y: 850,
        },
        {
          x: 55,
          y: 930,
        },
      ],
    };
  },
  mounted() {
    this.$wx();

    const city = this.$route.query.city;
    if (!city) {
      return;
    }
    let targetY = 0;
    this.hotPoints.forEach((p, i) => {
      if (p.city === city) {
        targetY = p.y;
      }
    });
    let height = (window.innerWidth * targetY) / 100;
    height -= window.innerHeight / 2;
    this.$refs.container.scrollTop = height;
  },
  methods: {
    next(city) {
      this.$router.replace(`/detail/${city}`);
    },

    compute640(x) {
      if (window.innerWidth > 640) {
        return 6.4 * x;
      } else {
        return (window.innerWidth / 100) * x;
      }
    },

    compute640Point(x) {
      if (window.innerWidth > 640) {
        return 6.4 * x + 640 * 0.2 - 16;
      } else {
        return (window.innerWidth / 100) * x + window.innerWidth * 0.2 - 16;
      }
    },
  },
};
</script>

<style scoped>
.thirteen-container {
  width: 100%;
  height: 100vh;
  overflow: auto;
}

.img-container {
  position: relative;
  min-height: 1000.186vw;
  overflow: hidden;
}

@media screen and (min-width: 640px) {
  .img-container {
    min-height: 6200px;
  }
}

.thirteen-img {
  width: 100%;
}

.point-container {
  position: absolute;
  left: 0;
  width: 100vw;
  height: 40vw;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.point-img {
  width: 32px;
  animation: shine 2s infinite linear;
}

.cloud-container img {
  position: absolute;
  user-select: none;
  pointer-events: none;
}

.c1 {
  width: 50vw;
  animation: cloud-float-c1 10s infinite ease-in-out;
}

.c2 {
  width: 62vw;
  animation: cloud-float-c2 8s infinite ease-in-out;
}

.c3 {
  width: 60vw;
  animation: cloud-float-c3 12s infinite ease-in-out;
}

@keyframes shine {
  from {
    transform: scale(0.9);
    opacity: 0.7;
  }

  50% {
    transform: scale(1.1);
    opacity: 1;
  }

  to {
    transform: scale(0.9);
    opacity: 0.7;
  }
}

@keyframes cloud-float-c1 {
  from {
    transform: translateX(-25%);
  }

  50% {
    transform: translateX(25%);
  }

  to {
    transform: translateX(-25%);
  }
}

@keyframes cloud-float-c2 {
  from {
    transform: translateX(0%);
  }

  50% {
    transform: translateX(-50%);
  }

  to {
    transform: translateX(0%);
  }
}

@keyframes cloud-float-c3 {
  from {
    transform: translateX(0%);
  }

  50% {
    transform: translateX(50%);
  }

  to {
    transform: translateX(0%);
  }
}

@media screen and (min-width: 640px) {
  .point-container {
    width: 256px;
    height: 256px;
  }

  .c1 {
    width: 320px;
  }

  .c2 {
    width: 396px;
  }

  .c3 {
    width: 384px;
  }
}
</style>